import React from 'react';
import { useSelector } from 'react-redux';
import { Collapse } from 'reactstrap';
import FilterSearch from '../FilterSearch';
import SearchToggles from './SearchToggles/SearchToggles';

const TextSearchCollapser = ({onSearchOpen}) => {
    // bool to show text search section
    const searchActive = useSelector(state => state.toggle.isSidebarPracticeSearchOpen);

    return (
        <Collapse isOpen={searchActive} onTransitionEnd={onSearchOpen}>
            <div className="w-100 justify-content-center px-3">
                <FilterSearch />
                <SearchToggles />
            </div>
        </Collapse>
    );
};

export default TextSearchCollapser;
